export enum ECexBotFilter {
  buy_sell = 'buy_sell',
  buy_sell_v2 = 'buy_sell_v2',
  order_book = 'order_book',
  organic = 'organic',
  regular = 'regular',
  dn_orderbook = 'dn-orderbook',
  cm = 'cm',
  fg = 'fg',
  abuse_protection = 'abuse_protection',
  arbitrage = 'arbitrage',
  counter_order = 'counter_order',
  order_manager = 'order_manager',
  index = 'index',
  unknown = 'unknown',
  common = 'common',
  orderbook_dynamic = 'orderbook_dynamic',
}
